<template>
  <div>
    <!-- Card do provedor (provedores) -->
    <v-hover v-if="type === 'providers'" v-slot="{ hover, props }">
      <v-card
        class="cardProvider cursor-pointer d-flex align-center flex-column py-3 px-6"
        v-bind="props"
        outlined
        :width="styleCardProvider.width"
        :style="{
          backgroundColor: 'transparent',
          borderRadius: '8px',
        }"
        @click.stop="cardClick(item)"
      >
        <div
          v-if="!imageError"
          class="cardProviderBackgroundImageGrid"
          :style="{
            ...styleCardProvider.style,
            '--providerBackgroundGrid': `url(${
              hover ? item.srcColor : item.src
            })`,
          }"
        ></div>
        <div
          v-else
          class="d-flex text-center flex-column justify-center align-center"
          :style="{
            width: '100%',
            height: '64px',
          }"
        >
          <v-icon size="24" class="pb-1">mdi-poker-chip</v-icon>
          <span style="font-size: small">{{ item.name }}</span>
        </div>
      </v-card>
    </v-hover>

    <!-- Card do jogo (lobby e categorias) -->
    <v-card
      v-else
      :ripple="false"
      color="transparent"
      :width="styleCardGame.width"
      elevation="0"
    >
      <!-- img -->
      <div
        v-if="imageError === false"
        class="imageGame cursor-pointer"
        @click.stop="cardClick(item)"
        :style="styleCardGame"
      ></div>
      <!-- name, provider, info -->
      <v-hover v-slot="{ hover }">
        <div
          @click.stop="clickDetail(item)"
          class="d-flex cursor-pointer justify-space-between align-center mt-1 caption subtitle-2"
        >
          <div class="text-truncate">
            <!-- name -->
            <div class="text-truncate font-weight-bold">
              {{ item.title_game }}
            </div>
            <!-- provider -->
            <div class="grey--text text-truncate">
              {{ item.name_provider }}
            </div>
          </div>
          <!-- info -->
          <div class="pl-1" v-show="!$vuetify.breakpoint.xs">
            <v-icon :color="hover ? 'primary' : 'grey'" size="20">
              {{ hover ? "mdi-information" : "mdi-information-outline" }}
            </v-icon>
          </div>
        </div>
      </v-hover>
    </v-card>

    <ItemDialog
      :dialog="itemDialog"
      :type="type"
      :categoryName="categoryName"
      :item="viewingItem"
      @closeItemDialog="closeItemDialog"
    />
  </div>
</template>

<script>
import ItemDialog from "./itemDialog";

export default {
  props: ["item", "type", "isMobile", "categoryName"],

  data: () => ({
    itemDialog: false,
    viewingItem: false,
    imageError: false,
  }),

  components: { ItemDialog },

  watch: {
    "$route.params.casinoType"() {
      if (this.imageError) {
        this.imageError = false;
      }
    },
  },

  computed: {
    src() {
      return this.item.src;
    },

    height() {
      if (this.$vuetify.breakpoint.sm) {
        return 130;
      }

      if (this.$vuetify.breakpoint.xs) {
        if (this.$vuetify.breakpoint.width < 400) {
          return 90;
        } else {
          return 112;
        }
      }

      return "auto";
    },

    styleCardProvider() {
      var defaultStyle = {
        backgroundSize: "contain",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        boxSizing: "border-box",
      };

      var itemsPerScreen, discount, baseWidth, marginView;
      var wrapCategory = document.querySelector(".wrapContent");

      if (!wrapCategory) {
        return {};
      }

      // Calculando a distribuição dos cards de provedores por screen
      itemsPerScreen = this.$vuetify.breakpoint.name === "xs" ? 2 : 6;
      discount = this.$vuetify.breakpoint.name === "xs" ? 24 : 80;
      marginView = 16 * 2; // No Lobby tem uma classe px-4 no wrapContent
      baseWidth = wrapCategory.clientWidth - marginView;

      return {
        width: (baseWidth - discount) / itemsPerScreen,
        style: {
          width: 100 + "%",
          height: 64 + "px",
          ...defaultStyle,
        },
      };
    },

    // handler card mobile width/height
    styleCardGame() {
      const fallbackImage = require("@/assets/fallback.png");

      var defaultStyle = {
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${this.src}), url(${fallbackImage})`,
        boxSizing: "border-box",
        borderRadius: "2rem",
        border: "1px solid rgba(255,255,255,0.1)",
      };
      var itemsPerScreen, discount, baseWidth, square, marginView;
      var wrapCategory = document.querySelector(".wrapContent");
      marginView = 16 * 2; // No Lobby tem uma classe px-4 no wrapContent

      if (!wrapCategory) {
        return {};
      }

      switch (this.$vuetify.breakpoint.name) {
        case "xs": // < 600px
          itemsPerScreen = 3;
          discount = this.$route.name === "casinoLobby" ? 64 : 32;
          baseWidth = wrapCategory.clientWidth;
          square = (baseWidth - discount) / itemsPerScreen;
          return {
            width: square + "px",
            height: square + "px",
            ...defaultStyle,
          };
        case "sm": // 600 px > < 960 px
        case "md": // 960px > < 1264px*
        case "lg": // 1264px > < 1904px*
        case "xl": // > 1904px*
          itemsPerScreen = 6;
          discount = 80;
          baseWidth = wrapCategory.clientWidth - marginView;
          square = (baseWidth - discount) / itemsPerScreen;
          return {
            width: square + "px",
            height: square + "px",
            ...defaultStyle,
          };
        default:
          return {
            width: "190px",
            height: "190px",
            ...defaultStyle,
          };
      }
      // * -16px na área de trabalho para a barra de rolagem do navegador
    },
  },

  methods: {
    onImageError() {
      this.error = true;
    },

    clickDetail(item) {
      if (this.type !== "providers") {
        this.itemDialog = true;
        this.viewingItem = item;
      } else {
        this.$emit("toRoute", item);
      }
    },

    cardClick(item) {
      if (this.type === "providers") {
        this.$router.push({
          name: "casinoProvider",
          params: { providerId: item.id },
        });

        return;
      }

      if (this.$vuetify.breakpoint.mobile) {
        this.itemDialog = true;
        this.viewingItem = item;
      } else {
        this.gameClicked({ item, demo: false });
      }
    },

    gameClicked({ item }) {
    // gameClicked({ item, demo }) {
      // if (!this.$store.state.logged.status) {
      //   const casinoType = this.$route.params.casinoType;

      //   const gameRouteType =
      //     this.type === "provider" ? "providers" : "category";

      //   const value =
      //     this.type === "provider"
      //       ? this.$route.params.providerId
      //       : this.categoryName
      //       ? this.categoryName
      //       : this.$route.params.category;

      //   item.redirectUrl = `/casino/lobby/${casinoType}/${gameRouteType}/${value}/game/${item.game_id}`;
      //   item.redirectUrl += `?demo=${!!demo}`;

      //   this.$root.$emit("openUnloggedDialog", item);
      //   return;
      // }

      if (this.type === "provider") {
        this.$router.push({
          name: "casinoGameProvider",
          params: {
            gameId: item.game_id,
            casinoType: this.$route.params.casinoType,
          },
          // query: { demo },
          ...(this.$vuetify.breakpoint.mobile
            ? {
                firstViewGame: true,
              }
            : {}),
        });
      } else if (
        this.type === "category" ||
        (this.type === "lobby" && this.categoryName)
      ) {
        const params = {
          gameId: item.game_id,
        };

        if (this.type === "lobby") {
          params.category = this.categoryName;
        }

        this.$router.push({
          name: "casinoGameCategory",
          params,
          query: {
            // demo,
            ...(this.$vuetify.breakpoint.mobile
              ? {
                  firstViewGame: true,
                }
              : {}),
          },
        });
      } else if (this.type === "favorites") {
        const query = { demo: false };

        if (this.$vuetify.breakpoint.mobile) {
          query.firstViewGame = true;
        }

        this.$router.push({
          name: "casinoGameFavorites",
          params: {
            gameId: item.game_id,
            casinoType: this.$route.params.casinoType,
          },
          query,
        });
      } else {
        // const query = { demo: false };
        let query = {};

        if (this.$vuetify.breakpoint.mobile) {
          query.firstViewGame = true;
        }

        this.$router.push({
          name: "casinoGame",
          params: {
            gameId: item.game_id,
            casinoType: this.$route.params.casinoType,
          },
          query,
        });
      }
    },

    closeItemDialog() {
      this.itemDialog = false;
      this.viewingItem = {};
    },
  },
};
</script>
<style>
:root {
  --providerBackgroundGrid: "";
}

.cardProvider {
  transition: all 0.1s linear;
}

.cardProvider:hover {
  background-color: rgba(255, 255, 255, 0.9) !important;
}

.cardProviderBackgroundImageGrid {
  background-image: var(--providerBackgroundGrid);
  transition: all 0.5s linear;
}

.game-info {
  position: absolute;
  top: 0px;
  width: 100%;
  padding: 0.3rem 1rem;
  width: 100%;
  border-radius: 24px 24px 0 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.85), transparent);
}

.imageErrorIcon .v-icon {
  font-size: 52px !important;
}

.image {
  position: relative;
  display: inline-block;
}

.overlay {
  display: none;
}

.image:hover .overlay {
  width: 100%;
  height: fit-content;
  border-radius: 0 0 24px 24px;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  box-shadow: 0 0 0 100vmax inset rgb(0 0 0 / var(--o, 0%));
  transition: 0.4s;
}

.imageGame {
  position: relative;
  transition: all 0.1s linear;
}

.imageGame:hover {
  scale: 104%;
  translate: 0px -8px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.85);
}
</style>
